export default __webpack_public_path__ + "static/media/testimonial-blue.aef074ab.svg";